<template>
  <footer>
    <div class="container">
      Gestoría KNK — Gestoría Administrativa Moreno Moraleda<br>
      C. La Rampa, 4<br>
      29500 Álora (Málaga)<br>
      <a href="info@gestoriaknk.es">info@gestoriaknk.es</a><br>
      Fijo: <a href="tel:+34951476668">951 47 66 68</a><br>
      Móvil: <a href="https://wa.me/+34722435896">+34 722 435 896</a><br>
      <div class="privacidad">
        <router-link to="/aviso-legal">
          Política de privacidad y aviso legal
        </router-link>
      </div>
    </div>
    <cookie-law 
      theme="blood-orange"
      buttonText="Aceptar">
      <div slot="message">
        Esta web utiliza cookies operativas propias con una finalidad puramente funcional y de terceros para personalizar contenido, proporcionar mejores funcionalidades y analizar nuestro tráfico.
        Haciendo click en "Aceptar" consientes el uso de esta tecnología en nuestra web.
      </div>
    </cookie-law>
  </footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law';

export default {
  components: {
    CookieLaw,
  }
  
}
</script>

<style scoped>

footer a,
footer a:active,
footer a:visited {
  color: white;
}
.privacidad {
  position: absolute;
  right: 0px;
  bottom: 0px;
}
footer {
  padding: 50px 0px;
  background-color: var(--app-footer);
  color: white;
}

@media screen and (max-width: 560px){
  .privacidad {
    margin-top: 30px;
    position: relative;
  }
  footer {
    text-align: center;
  }
}
</style>
